import { FC, useEffect, useMemo, useRef, useState } from "react";
import { Chip, Stack } from "@mui/material";
import { formatElapsedTime } from "@utils/formatting.util";
import CircleIcon from "@mui/icons-material/Circle";

const Timer: FC<{ startTime: Date | null; variant?: "dark" | "light" }> = ({
  startTime,
  variant = "dark",
}) => {
  const [elapsedTime, setElapsedTime] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>();

  useEffect(() => {
    if (!startTime) {
      return;
    }
    intervalRef.current = setInterval(() => {
      setElapsedTime(startTime ? Date.now() - startTime.getTime() : 0);
    }, 100);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [startTime]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const style = useMemo(() => {
    return {
      backgroundColor: variant === "dark" ? "#000" : "#fff",
      color: variant === "dark" ? "#fff" : "#000",
    };
  }, [variant]);

  return (
    <Chip
      size="small"
      sx={style}
      label={
        <Stack
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          minWidth="52px"
        >
          <CircleIcon
            color="error"
            sx={{ width: "10px", marginRight: "5px" }}
          />
          {formatElapsedTime(elapsedTime)}
        </Stack>
      }
      variant={variant === "light" ? "outlined" : "filled"}
    />
  );
};

export default Timer;
